import React from "react";

import ReactTable from "react-table";
import {Button} from "reactstrap";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Objects} from "components";
import {confirmAlert} from "react-confirm-alert";
import CollectionOverride from "components/CollectionOverride";
import UniversalModalOverride from "components/UniversalModalOverride";


const {getFullID} = Framework.Utilities;

export default class AcquisitionPendingsProducts extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Acquisitions_Pendings_Products._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 6;
		this.limit = 6;
		this.state.current_id = null;
		this.state.current_object = null;
		this.state.modalAcquisitionProductUpdate = false;
		this.state.showUPC = false;
	}

	handleReviewEditClick = (e) => {
		const current_id = e.currentTarget.name;
		let current_object = this.state.data.find(item => (item.binary_id + '-' + item.pkey) === current_id);
		this.setState({
			current_id,
			current_object,
			modalAcquisitionProductUpdate: true
		});
	}



	handleReviewDeleteClick = (e) => {
		const pkey = parseInt(e.currentTarget.id);
		const binary_id = e.currentTarget.getAttribute('binary-id');
		confirmAlert({
			title: 'Confirm Delete',
			message: 'Are you sure you want to remove this product?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						this.setState({loading: true});
						let teModel = new API.BuildClass(Types.Acquisitions_Pendings_Products._name, API.RequestType.READ);
						teModel.object.pkey = pkey;
						teModel.object.binary_id = binary_id;
						teModel.parent = this.model.parent;
						teModel.parent_binary_id = this.model.parent_binary_id;
						await teModel.submit(null, API.RequestType.DELETE);
						this.setState({loading: false});
						this.props.reloadPage();
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "SKU",
				id: "sku",
				accessor: obj => (obj.upc ? obj.upc : obj.sku)
			},
			{
				Header: "Type",
				accessor: "type",
			},
			{
				Header: "Model",
				accessor: "model",
			},
			{
				Header: "Serial",
				id: "serial_number",
				/** @param {Products_Object} obj */
				accessor: obj => (obj.serial_number),
			},
			{
				Header: 'UPC',
				accessor: 'upc',
				show: !!this.state.showUPC
			},
			{
				Header: "Manufacturer",
				id: 'manufacturer',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.manufacturer ? obj.manufacturers.name : obj.manufacturer_other)
			},
			{
				Header: "Importer",
				id: 'importer',
				/** @param {Products_Object} obj */
				accessor: 'importer',
			},
			{
				Header: "Caliber",
				id: 'caliber',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.caliber ? obj.calibers.name : obj.caliber_other)
			},
			{
				Header: "Item Description",
				accessor: 'item_description'
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 110,
				Cell: props => {
					return (
						<span>
							<Button
								id={props.original.pkey}
								binary-id={props.original.binary_id}
								onClick={this.handleReviewDeleteClick}
								size={"sm"}
								color="danger">
								Delete Product
							</Button>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 100,
				Cell: props => {
					return (
						<span>
							<Button
								name={getFullID(props.original)}
								onClick={this.handleReviewEditClick}
								size={"sm"}
								color="green-meadow">
								Review / Edit
							</Button>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						history={this.props.history}
						parent={this.props.parent}
						id={this.state.current_id}
						name={"Product"}
						object={Objects.AcquisitionProductUpdate}
						objectProps={{
							object: this.state.current_object
						}}
						toggle={this.state.modalAcquisitionProductUpdate}
						reportClose={this.reportClose('modalAcquisitionProductUpdate')}
						hasGoTo={false}
						afterSave={this.props.reloadPage}
					/>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Products', "")}
								{this.renderHeaderRight('Products', columns)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[6, 10, 20, 25, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
